import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    light: true,
    options: {
      customProperties: true
    },
    themes: {
      // Default theme - will be overwitten by LoanEnquiryConfig.Theme
      light: {
        background:'#F1F1F1',
        primary: '#bab8b8',
        'primary-lighten-1': '#213b4a', //Title Section
        secondary: '#00728f', //Main Btn
        'secondary-darken-1': '#00728f', //Gradiant Btn and input border
        tertiary: '#73777B', 
        accent: '#E5F7F7',
        error: '#F26D6D',
        label: '#213b4a',
        'label-lighten-1': '#8f979d', //60% opacity
        table:'#E7E9EB',
        stepper:'#00AFAD',
        StepperTitle:'#213b4a',
        text: '#213b4a',
        'text-darken-1': '#213b4a',
        InfoBanner: '#D9EBF4',
        'InfoBanner-darken-1': '#018ff2',
        SuccessBanner:'#E5F7F7',
        'SuccessBanner-darken-1': '#00AFAD',
        ErrorBanner:'#F6E4E4',
        'ErrorBanner-darken-1': '#AF0000',
        WarningBanner:'#F6F2E4',
        'WarningBanner-darken-1': '#AF8600',
        NumberedBox:'#00AFAD', //Eligible Number Box
        'NumberedBox-lighten-1': '#E0F2F2', //10% opacity
      }
    }
  }
});